const turf = require('@turf/turf')
export function Polygonstr(feture_cord){
    let geom_str
    let _str = feture_cord.map(position => `${position[0]} ${position[1]}`).join(',') 
    geom_str = `POLYGON((${_str}))`
    return geom_str
  }

export function Pointstr(feture_cord){
    let geom_str
    let _str = `${feture_cord[0]} ${feture_cord[1]}`
    geom_str = `POINT(${_str})`
    return geom_str
  }

export function Feature_area(feature_cord) {
    var sqmeter_to_acre = 0.000247105
    let _feture_area = 0
    let polygon = turf.polygon(feature_cord);
    _feture_area = turf.area(polygon)*sqmeter_to_acre
    return _feture_area
  }
  
export function Poly_centroid(feature_cord){
    let _feture_centroid = ''
    let polygon = turf.polygon(feature_cord);
     _feture_centroid = turf.pointOnSurface(polygon)
   return _feture_centroid
  }

//   module.exports = {
//     Polygonstr,
//     Pointstr,
//     Feature_area,
//     Poly_centroid
// };
  

